<template>
  <div ref="list" class="list">
    <div class="container">
      <a-row :gutter="[20,0]">
        <a-col :xs="24" :xl="16">
          <a-skeleton :loading="request.data.list.length===0" active>
            <div class="box_card">
              <router-link v-for="item in request.data.list" class="card"
                           :to="`${$Enum.RouterEnum.NewsDetail}?id=${item.article_id}`">
                <a-row :gutter="[20,0]">
                  <a-col :xs="0" :sm="10" :md="8">
                    <div class="image">
                      <i :style="{backgroundImage:`url('${item.article_cover_address}')`}" />
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="14" :md="16">
                    <div class="content">
                      <a-typography-title :level="5">
                        {{ item.article_title }}
                      </a-typography-title>
                      <a-typography-paragraph>
                        {{ item.article_introduction }}
                      </a-typography-paragraph>
                      <span class="date">
                        {{ $FN.Time.format(item.published_at * 1000) }}
                      </span>
                    </div>
                  </a-col>
                </a-row>
              </router-link>
            </div>
            <a-pagination v-model:current="expand.pagination.current"
                          :size="$Store.Public().width<$Enum.GridEnum.MD?'small':''"
                          :total="expand.pagination.total"
                          :pageSize="expand.pagination.pageSize" :pageSizeOptions="['10', '20', '50']"
                          @change="expand.pagination.onChange"
                          showLessItems showQuickJumper showSizeChanger />
          </a-skeleton>
        </a-col>
        <a-col :xs="0" :xl="8">
          <div class="box_qr">
            <img alt=""
                 :src="file.ImageQR" />
            <p>
              扫码添加小助手，回复“白皮书”<br>
              获取更多行业干货
            </p>
            <span></span>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import { RequestGetNewsList, ResponseGetNewsList, AxiosGetNewsList } from '@server/apiNews';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'newsList',
  data(): DataInterface {
    return {
      file: {
        ImageQR
      },
      request: {
        intercept: {
          list: false
        },
        data: {
          list: []
        }
      },
      form: {
        data: {
          page_number: 1,
          page_size: $Config.Template.pagination.pageSize
        }
      },
      expand: {
        pagination: {
          total: 0,
          current: 1,
          pageSize: $Config.Template.pagination.pageSize,
          onChange: (current: any, pageSize: any): void => {
            this.expand.pagination.current = current;
            this.expand.pagination.pageSize = pageSize;
            this.scroll();
            this.getList();
          }
        }
      }
    };
  },
  mounted(): void {
    this.getList();
  },
  methods: {
    /**
     * 滚动至新闻列表顶部
     */
    scroll(): void {
      const domList = this.$refs.list;
      
      if (!domList) return;
      
      window.scrollTo(0, 0);
      window.scrollTo(0, domList.getBoundingClientRect().top - ($Store.Public().isGridMatch('>=', $Enum.GridEnum.XL) ? 110 : 60) - 20);
    },
    
    /**
     * 获取列表
     */
    getList(): void {
      this.form.data.page_number = this.expand.pagination.current;
      this.form.data.page_size = this.expand.pagination.pageSize;
      
      if (this.request.intercept.list) return;
      this.request.intercept.list = true;
      
      AxiosGetNewsList(this.form.data as RequestGetNewsList)
        .then((response: any) => {
          const data: ResponseGetNewsList = response.data;
          
          this.request.intercept.list = false;
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          this.request.data.list = data.data.article_data;
          this.expand.pagination.total = data.data.total;
          
          this.form.data.page_number === 1 && $Store.Page().checkPointNews(true);
        })
        .catch(() => {
          this.request.intercept.list = false;
        });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/news/';

.list {
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: 0 @padding 120px;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}

.box_card {
  position: relative;
  
  .card {
    display: block;
    position: relative;
    height: 200px;
    padding: 20px 0;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    &:hover {
      .image {
        i {
          .transform(scale(1.1));
        }
      }
      
      .content {
        .ant-typography,
        .date {
          color: @color_1;
        }
      }
    }
    
    .image {
      overflow: hidden;
      position: relative;
      width: 100%;
      height: 160px;
      border-radius: 5px;
      
      i {
        .position();
        z-index: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        .transition(transform @time);
        pointer-events: none;
      }
    }
    
    .content {
      position: relative;
      width: 100%;
      height: 160px;
      
      h5.ant-typography {
        margin-bottom: 15px;
        .font(justify, 28px, @color_3, 20px, true);
        .ellipsis(2);
      }
      
      div.ant-typography {
        margin-bottom: 0;
        .font(justify, 22px, @color_3, @font_7);
        .ellipsis(2);
      }
      
      .ant-typography {
        .transition(color @time);
      }
      
      .date {
        display: block;
        .position(bottom);
        .font(justify, 20px, @color_3, @font_7);
        .transition(color @time);
      }
    }
  }
}

.box_qr {
  overflow: hidden;
  position: relative;
  height: 255px;
  margin-top: 20px;
  .borderBox();
  border: 1px solid @color_4;
  border-radius: 5px;
  
  &::before {
    content: "";
    display: block;
    .position(bottom);
    z-index: 0;
    .bg('@{image}qr_bg.jpg', 100%, 140px, true);
  }
  
  img {
    display: block;
    .position(top, 30px);
    width: 150px;
    margin: 0 auto;
  }
  
  p {
    @ph: 20px;
    .position(top, 180px);
    width: 220px;
    height: @ph;
    margin: 0 auto;
    .font(center, @ph, @color_black, @font_7);
  }
  
  span {
    @ph: 20px;
    .position(top, 200px);
    width: 220px;
    height: @ph;
    margin: 0 auto;
    .font(center, @ph, @color_3, @font_7);
  }
}

.ant-pagination {
  margin-top: 80px;
  text-align: center;
}

@media screen and (max-width: -1px+@grid_md) {
  .list {
    padding: 0 @padding 50px;
  }
  
  .ant-pagination {
    margin-top: 30px;
  }
}
</style>